export default "__VITE_ASSET__DXS$WlwB__"